import { Component, Input } from '@angular/core';

@Component({
    selector: 'site-layout',
    templateUrl: './site-layout.component.html',
    styleUrls: ['./site-layout.component.scss'],
    standalone: false
})
export class SiteLayoutComponent {
  @Input() hideHeader = false;

  constructor() { }

}
